module.exports = {
    title: '豆慧充',
    fixedHeader: false,
    sidebarLogo: false
};
